import { apmBase } from '@elastic/apm-rum';

export const withSpan = async <T,>(message: string, fn: () => Promise<T>) => {
  const span = apmBase.startSpan(message);
  try {
    return await fn();
  } finally {
    span?.end();
  }
};